export const getFavoriteLeagueImagePath = (sportShortSign: string, leagueId: number) => {
  switch (sportShortSign) {
    case 'fu': {
      const imgId = (leagueId % 12) + 1
      return `/favorites/soccer/Soccer_Placeholder-${imgId}.webp`
    }
    case 'ba':
      return '/favorites/Basketball_Placeholder-1.webp'
    case 'af':
      return '/favorites/AmericanFootball_Placeholder-1.webp'
    case 'ho':
      return '/favorites/IceHockey_Placeholder-1.webp'
    case 'rg':
      return '/favorites/Rugby_Placeholder-1.webp'
    case 'te':
      return '/favorites/Tennis_Placeholder-1.webp'
    case 'ha':
      return '/favorites/Handball_Placeholder-1.webp'
    case 'csgo':
      return '/favorites/CounterStrike_Placeholder-1.webp'
    case 'vo':
      return '/favorites/Volleyball_Placeholder-1.webp'
    case 'bm':
      return '/favorites/Badminton-1.webp'
    case 'ml':
      return '/favorites/Baseball_Placeholder-1.webp'
    case 'sn':
      return '/favorites/Snooker_Placeholder-1.webp'
    case 'fs':
      return '/favorites/Futsal_Placeholder-1.webp'
    case 'fb':
      return '/favorites/Floorball_Placeholder-1.webp'
    case 'sqsh':
      return '/favorites/Squash_Placeholder-1.webp'
    case 'cr':
      return '/favorites/Cricket_Placeholder-1.webp'
    case 'wp':
      return '/favorites/Waterpolo_Placeholder-1.webp'
    case 'mo':
      return '/favorites/Motorsport_Placeholder-1.webp'
    case 'da':
      return '/favorites/Darts_Placeholder-1.webp'
    case 'tt':
      return '/favorites/TableTennis_Placeholder-1.webp'
    case 'bvb':
      return '/favorites/BeachVolley_Placeholder-1.webp'
    case 'sc':
      return '/favorites/StarCraft_Placeholder-1.webp'
    // case 'bd':
    //   return '/favorites/Bandy_Placeholder-1.webp'
    case 'bs':
      return '/favorites/BeachSoccer_Placeholder-1.webp'
    case 'bx':
      return '/favorites/Boxing_Placeholder-1.webp'
    case 'cu':
      return '/favorites/Curling_Placeholder-1.webp'
    case 'lol':
      return '/favorites/ESportLeagueOfLegends_Placeholder-1.webp'
    case 'go':
      return '/favorites/Golf_Placeholder-1.webp'
    case 'dota2':
      return '/favorites/ESportDota_Placeholder-1.webp'
    case 'fh':
      return '/favorites/FieldHockey_Placeholder-1.webp'
    case 'mma':
      return '/favorites/MMA_Placeholder-1.webp'
    case 'ow':
      return '/favorites/Overwatch_Placeholder-1.webp'
    case 'bo':
      return '/favorites/Bowls_Placeholder-1.webp'
    case 'bln':
      return '/favorites/Biathlon_Placeholder-1.webp'
    case 'cc':
      return '/favorites/CrossCountry_Placeholder-1.webp'
    case 'si':
      return '/favorites/AlpineSkiing_Placeholder-1.webp'
    // case 'ar':
    //   return '/favorites/AussieRules_Placeholder-1.webp'
    case 'cod':
      return '/favorites/CallOfDuty_Placeholder-1.webp'
    case 'sj':
      return '/favorites/SkiJumping_Placeholder-1.webp'
    case 'cyc':
      return '/favorites/Cycling_Placeholder-1.webp'
    // case 'pe':
    //   return '/favorites/Pesapallo_Placeholder-1.webp'
    // case '_specials':
    //   return '/favorites/Specials_Placeholder-1.webp'
    case 'nba2k':
      return '/favorites/eBasketball_Placeholder-1.webp'
    // case 'at':
    //   return '/favorites/Athletics_Placeholder-1.webp'
    case 'pu':
      return '/favorites/ESportPlayerUnknonwsBattleground_Placeholder-1.webp'
    // case 'nc':
    //   return '/favorites/NordicCombines_Placeholder-1.webp'
    case 'fe':
      return '/favorites/FormulaE_Placeholder-1.webp'
    case 'hs':
      return '/favorites/Hearthstone_Placeholder-1.webp'
    // case 'gfb':
    //   return '/favorites/GaelicFootball_Placeholder-1.webp'
    case 'sail':
      return '/favorites/Sailing_Placeholder-1.webp'
    case 'ghu':
      return '/favorites/GaelicHurling_Placeholder-1.webp'
    case 'fifa':
      return '/favorites/eSoccer_Placeholder-1.webp'
    case 'rs':
      return '/favorites/RainbowSix_Placeholder-1.webp'
    case 'wow':
      return '/favorites/ESportWorldOfWarcraft_Placeholder-1.webp'
    case 'rl':
      return '/favorites/RocketLeague_Placeholder-1.webp'
    case 'go':
      return '/favorites/Golf_Placeholder-1.webp'

    default:
      return '/favorites/Generic_Placeholder-2.webp'
  }
}
